<template>
  <v-card flat class="pa-4">
    <!-- Snackbar -->
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <!-- Filtros y botón nuevo -->
    <v-row class="mb-3" align="center">
      <v-col cols="12" sm="4">
        <v-select v-model="filtroStatus" :items="statusOptions" label="Filtrar por estado"
          outlined dense hide-details clearable @change="cargarEventos"></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-btn-toggle v-model="filtroTemporal" dense color="deep-purple" @change="cargarEventos">
          <v-btn value="upcoming" small>Próximos</v-btn>
          <v-btn value="past" small>Pasados</v-btn>
          <v-btn value="all" small>Todos</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" sm="4" class="text-right">
        <v-btn color="deep-purple" dark @click="openDialog(null)">
          <v-icon left>mdi-plus</v-icon> Nuevo Evento
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla de eventos -->
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Título</th>
            <th>Categoría</th>
            <th>Tipo</th>
            <th>Estado</th>
            <th>Fecha inicio</th>
            <th>Temporal</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ev in eventos" :key="ev.id">
            <td>{{ ev.title }}</td>
            <td>
              <v-chip v-if="ev.category" x-small :color="ev.category.color || 'grey lighten-2'">
                {{ ev.category.name }}
              </v-chip>
              <span v-else class="grey--text">—</span>
            </td>
            <td>
              <v-chip x-small :color="tipoColor(ev.type)" dark>
                <v-icon x-small left>{{ tipoIcon(ev.type) }}</v-icon>
                {{ tipoLabel(ev.type) }}
              </v-chip>
            </td>
            <td>
              <v-chip x-small :color="statusColor(ev.status)" dark>
                {{ statusLabel(ev.status) }}
              </v-chip>
            </td>
            <td>{{ formatDate(ev.start_date) }}</td>
            <td>
              <v-chip x-small :color="temporalColor(ev.temporal_status)" dark>
                {{ temporalLabel(ev.temporal_status) }}
              </v-chip>
            </td>
            <td>
              <v-btn icon color="primary" small @click="openDialog(ev)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="red" small @click="eliminar(ev)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr v-if="eventos.length === 0">
            <td colspan="7" class="text-center grey--text pa-4">No hay eventos registrados.</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Paginación -->
    <v-row v-if="pagination.last_page > 1" justify="center" class="mt-3">
      <v-pagination v-model="pagination.current_page" :length="pagination.last_page"
        @input="cargarEventos" circle></v-pagination>
    </v-row>

    <!-- Dialog crear/editar evento -->
    <v-dialog v-model="dialog" max-width="650" persistent scrollable>
      <v-card>
        <v-card-title class="deep-purple darken-1 white--text">
          <v-icon left dark>mdi-calendar-star</v-icon>
          {{ editando ? 'Editar' : 'Nuevo' }} Evento
        </v-card-title>
        <v-card-text class="pt-4" style="max-height: 70vh;">
          <v-form ref="formEvent" v-model="validForm">

            <!-- ─── Información del evento ─── -->
            <p class="subtitle-2 grey--text text--darken-1 mb-2">Información del evento</p>

            <v-text-field v-model="form.title" label="Título *"
              :rules="[v => !!v || 'Requerido']" outlined dense></v-text-field>

            <v-row>
              <v-col cols="12" sm="4">
                <v-select v-model="form.event_category_id" :items="categorias"
                  item-text="name" item-value="id" label="Categoría"
                  outlined dense clearable></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select v-model="form.event_organizer_id" :items="organizadores"
                  item-text="name" item-value="id" label="Organizador"
                  outlined dense clearable></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select v-model="form.status" :items="statusOptionsForm"
                  item-text="text" item-value="value" label="Estado"
                  outlined dense></v-select>
              </v-col>
            </v-row>

            <v-radio-group v-model="form.type" row dense label="Tipo de evento *"
              :rules="[v => !!v || 'Requerido']">
              <v-radio label="Presencial" value="presencial" color="teal"></v-radio>
              <v-radio label="Virtual" value="virtual" color="purple"></v-radio>
              <v-radio label="Híbrido" value="hibrido" color="indigo"></v-radio>
            </v-radio-group>

            <v-textarea v-model="form.description" label="Descripción breve *"
              :rules="[v => !!v || 'Requerido']" outlined dense rows="3"
              hint="Resumen corto del evento (visible en la galería)" persistent-hint></v-textarea>

            <!-- Editor de contenido detallado -->
            <p class="subtitle-2 grey--text text--darken-1 mt-3 mb-2">Contenido detallado (opcional)</p>
            <div class="editor-container mb-3">
              <div ref="editorToolbar">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <button class="ql-link"></button>
                <button class="ql-clean"></button>
              </div>
              <div ref="editorBody" style="min-height: 120px;"></div>
            </div>

            <v-divider class="my-3"></v-divider>

            <!-- ─── Fecha ─── -->
            <p class="subtitle-2 grey--text text--darken-1 mb-2">Fecha</p>

            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="form.start_date" label="Fecha inicio *" type="datetime-local"
                  :min="todayMin" :rules="[v => !!v || 'Requerido']" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="form.end_date" label="Fecha fin"
                  type="datetime-local" :min="form.start_date" outlined dense></v-text-field>
              </v-col>
            </v-row>

            <!-- ─── URL virtual (solo si virtual/híbrido) ─── -->
            <div v-if="form.type === 'virtual' || form.type === 'hibrido'">
              <v-divider class="my-3"></v-divider>
              <p class="subtitle-2 grey--text text--darken-1 mb-2">Enlace virtual</p>

              <v-text-field v-model="form.virtual_url" label="URL de la reunión (Zoom, Meet, etc.)"
                outlined dense placeholder="https://"></v-text-field>
            </div>

            <v-divider class="my-3"></v-divider>

            <!-- ─── Imagen principal ─── -->
            <p class="subtitle-2 grey--text text--darken-1 mb-2">Imagen principal</p>

            <v-file-input v-model="imageFile" label="Seleccionar imagen" accept="image/*"
              prepend-icon="mdi-image" show-size dense outlined
              hint="Imagen de portada para la galería (máx 2MB)" persistent-hint></v-file-input>

            <v-img v-if="imagePreviewUrl" :src="imagePreviewUrl" max-height="150" contain
              class="rounded grey lighten-3 my-2"></v-img>

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="deep-purple" dark :loading="saving" @click="guardarEvento">
            {{ editando ? 'Actualizar' : 'Crear' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import eventService from '@/services/eventService.js';
import Compressor from 'compressorjs';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export default {
  name: 'EventAdmin',
  data() {
    return {
      eventos: [],
      categorias: [],
      organizadores: [],
      dialog: false,
      editando: false,
      validForm: true,
      saving: false,
      imageFile: null,
      quill: null,
      filtroStatus: null,
      filtroTemporal: 'all',
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 15,
        total: 0
      },
      form: this.emptyForm(),
      statusOptions: [
        { text: 'Todos', value: null },
        { text: 'Borrador', value: 'draft' },
        { text: 'Publicado', value: 'published' },
        { text: 'Cancelado', value: 'cancelled' },
      ],
      statusOptionsForm: [
        { text: 'Borrador', value: 'draft' },
        { text: 'Publicado', value: 'published' },
        { text: 'Cancelado', value: 'cancelled' },
      ],
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: '',
        timeout: 4000
      }
    };
  },
  computed: {
    imagePreviewUrl() {
      if (this.imageFile) {
        return URL.createObjectURL(this.imageFile);
      }
      if (this.editando && this.form.image) {
        return eventService.getImageUrl(this.form.id, this.form.image);
      }
      return '';
    },
    todayMin() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}T00:00`;
    }
  },
  watch: {
    'form.start_date'(newVal) {
      if (!newVal) return;
      if (!this.form.end_date || this.form.end_date < newVal) {
        this.form.end_date = newVal;
      }
    }
  },
  mounted() {
    this.cargarEventos();
    this.cargarCategorias();
    this.cargarOrganizadores();
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        event_category_id: null,
        event_organizer_id: null,
        title: '',
        description: '',
        body: '',
        type: 'presencial',
        status: 'draft',
        start_date: '',
        end_date: '',
        timezone: 'America/Asuncion',
        virtual_url: '',
        image: ''
      };
    },
    cargarEventos() {
      const params = {
        page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
      if (this.filtroStatus) params.status = this.filtroStatus;

      eventService.listarEventosAdmin(params).then(res => {
        this.eventos = res.data.data;
        this.pagination.current_page = res.data.current_page;
        this.pagination.last_page = res.data.last_page;
        this.pagination.total = res.data.total;
      }).catch(() => {
        this.showMsg('Error al cargar eventos', 'error');
      });
    },
    cargarCategorias() {
      eventService.listarCategorias().then(res => {
        this.categorias = res.data;
      });
    },
    cargarOrganizadores() {
      eventService.listarOrganizadores().then(res => {
        this.organizadores = res.data;
      });
    },
    initQuill() {
      if (this.quill) {
        this.quill.root.innerHTML = '';
        this.quill = null;
      }
      if (!this.$refs.editorBody) return;
      this.$refs.editorBody.innerHTML = '';
      this.quill = new Quill(this.$refs.editorBody, {
        theme: 'snow',
        modules: { toolbar: this.$refs.editorToolbar }
      });
      if (this.form.body) {
        this.quill.root.innerHTML = this.form.body;
      }
    },
    openDialog(ev) {
      this.imageFile = null;
      if (ev) {
        this.editando = true;
        this.form = {
          id: ev.id,
          event_category_id: ev.event_category_id,
          event_organizer_id: ev.event_organizer_id,
          title: ev.title,
          description: ev.description,
          body: ev.body || '',
          type: ev.type,
          status: ev.status,
          start_date: ev.start_date ? ev.start_date.slice(0, 16) : '',
          end_date: ev.end_date ? ev.end_date.slice(0, 16) : '',
          timezone: 'America/Asuncion',
          virtual_url: ev.virtual_url || '',
          image: ev.image || ''
        };
      } else {
        this.editando = false;
        this.form = this.emptyForm();
      }
      this.dialog = true;
      this.$nextTick(() => {
        this.initQuill();
      });
    },
    async guardarEvento() {
      if (!this.$refs.formEvent.validate()) return;

      this.saving = true;
      try {
        // Capturar contenido del editor
        if (this.quill) {
          const html = this.quill.root.innerHTML;
          this.form.body = (html === '<p><br></p>') ? '' : html;
        }

        const payload = {
          event_category_id: this.form.event_category_id,
          event_organizer_id: this.form.event_organizer_id,
          title: this.form.title,
          description: this.form.description,
          type: this.form.type,
          status: this.form.status,
          start_date: this.form.start_date,
          timezone: 'America/Asuncion'
        };

        if (this.form.body) payload.body = this.form.body;
        if (this.form.end_date) payload.end_date = this.form.end_date;
        if (this.form.virtual_url) payload.virtual_url = this.form.virtual_url;

        let eventId;
        if (this.editando) {
          const res = await eventService.updateEvento(this.form.id, payload);
          eventId = res.data.id;
          this.showMsg('Evento actualizado', 'success');
        } else {
          const res = await eventService.saveEvento(payload);
          eventId = res.data.id;
          this.showMsg('Evento creado', 'success');
        }

        // Subir imagen comprimida si se seleccionó
        if (this.imageFile && eventId) {
          const compressed = await this.compressImage(this.imageFile);
          const fd = new FormData();
          fd.append('image', compressed);
          await eventService.uploadImage(eventId, fd);
        }

        this.dialog = false;
        this.cargarEventos();
      } catch (err) {
        const msg = err.response && err.response.data && err.response.data.message;
        this.showMsg(msg || 'Error al guardar el evento', 'error');
      } finally {
        this.saving = false;
      }
    },
    eliminar(ev) {
      if (!confirm('¿Eliminar el evento "' + ev.title + '"?')) return;
      eventService.deleteEvento(ev.id).then(() => {
        this.showMsg('Evento eliminado', 'success');
        this.cargarEventos();
      }).catch(() => {
        this.showMsg('Error al eliminar', 'error');
      });
    },

    // ─── Compresión de imagen ─────────────────────────────────
    compressImage(file) {
      return new Promise((resolve) => {
        new Compressor(file, {
          quality: 0.7,
          maxWidth: 1280,
          convertSize: 500000,
          success: (compressedBlob) => {
            const name = file.name.replace(/\.(jpe?g|png|jfif|webp)$/i, '') + '.jpg';
            const compressedFile = new File([compressedBlob], name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(compressedFile);
          },
          error: (err) => {
            console.error('Error al comprimir imagen:', err.message);
            resolve(file); // fallback: enviar original
          },
        });
      });
    },

    // ─── Helpers de formato ───────────────────────────────────
    formatDate(dateStr) {
      if (!dateStr) return '—';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es-PY', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    tipoColor(type) {
      const map = { presencial: 'teal', virtual: 'purple', hibrido: 'indigo' };
      return map[type] || 'grey';
    },
    tipoIcon(type) {
      const map = { presencial: 'mdi-map-marker', virtual: 'mdi-video', hibrido: 'mdi-monitor-cellphone' };
      return map[type] || 'mdi-help';
    },
    tipoLabel(type) {
      const map = { presencial: 'Presencial', virtual: 'Virtual', hibrido: 'Híbrido' };
      return map[type] || type;
    },
    statusColor(status) {
      const map = { draft: 'orange', published: 'green', cancelled: 'red' };
      return map[status] || 'grey';
    },
    statusLabel(status) {
      const map = { draft: 'Borrador', published: 'Publicado', cancelled: 'Cancelado' };
      return map[status] || status;
    },
    temporalColor(ts) {
      const map = { upcoming: 'green lighten-1', ongoing: 'blue', past: 'grey' };
      return map[ts] || 'grey';
    },
    temporalLabel(ts) {
      const map = { upcoming: 'Próximo', ongoing: 'En curso', past: 'Finalizado' };
      return map[ts] || ts;
    },
    showMsg(text, type) {
      this.mensaje.text = text;
      this.mensaje.color = type === 'success' ? 'success' : 'error';
      this.mensaje.colorBtn = type === 'success' ? 'green darken-1' : 'red darken-1';
      this.mensaje.snackbar = true;
    }
  }
};
</script>

<style scoped>
.editor-container {
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
